import { Directive, Input, TemplateRef } from '@angular/core';

/** @description директива предназначена для удобной компоновки шаблонов и именованием их */
@Directive({
  selector: '[gasTemplate]',
})
export class GasTemplateDirective {

  @Input('gasTemplate')
  public name: string;

  constructor(
    public template: TemplateRef<HTMLElement>,
  ) {}
}
